import type { SlideChapterDefinition } from '@/components/SlideWizard'
import Slide1Title from './slides/Slide1Title'
import Slide4WhyItWorks from './slides/Slide4WhyItWorks'
import Slide2Margaret from './slides/Slide2Margaret'
import Slide3TwoSteps from './slides/Slide3TwoSteps'
import Slide5Bridge from './slides/Slide5Bridge'
import Slide6Tips from './slides/Slide6Tips'
import Slide7Bridge from './slides/Slide7Bridge'
import Slide7BankExample from './slides/Slide7BankExample'
import Slide8CreditLetter from './slides/Slide8CreditLetter'
import Slide8bFraudCall from './slides/Slide8bFraudCall'
import Slide9Practice from './slides/Slide9Practice'
import Slide9bPractice from './slides/Slide9bPractice'
import Slide9cToolBridge from './slides/Slide9cToolBridge'
import Slide10Close from './slides/Slide10Close'

export const pauseAndVerifyChapter: SlideChapterDefinition = {
  id: 'pause-and-verify',
  title: 'Pause and Verify',
  description: 'A simple two-step habit that stops most scams before they start.',
  estimatedMinutes: 8,
  slides: [
    { id: 'pv-title', component: Slide1Title, label: 'Introduction' },
    { id: 'pv-elaine', component: Slide4WhyItWorks, label: 'Why pausing works' },
    { id: 'pv-concept', component: Slide2Margaret, label: 'Margaret\u2019s story' },
    { id: 'pv-pause', component: Slide3TwoSteps, label: 'The two-step habit' },
    { id: 'pv-verify', component: Slide5Bridge, label: 'How to verify safely' },
    { id: 'pv-tips', component: Slide6Tips, label: 'Verification tips' },
    { id: 'pv-bridge', component: Slide7Bridge, label: 'Putting it into practice' },
    { id: 'pv-bank-example', component: Slide7BankExample, label: 'Example: Bank call' },
    { id: 'pv-credit-letter', component: Slide8CreditLetter, label: 'Example: Credit letter' },
    { id: 'pv-fraud-call', component: Slide8bFraudCall, label: 'Example: Fraud call' },
    { id: 'pv-practice', component: Slide9Practice, label: 'Exercise: Spot the scam', requiresInteraction: true },
    { id: 'pv-practice-2', component: Slide9bPractice, label: 'Exercise: What would you do?', requiresInteraction: true },
    { id: 'pv-tool-bridge', component: Slide9cToolBridge, label: 'Helpful tools' },
    { id: 'pv-close', component: Slide10Close, label: 'Chapter summary' },
  ],
}
